import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BankDocuments from "../components/BankDocuments";


const ChatMessagePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Bank Documents" />

        {/* BankDocuments */}
        <BankDocuments />


      </MasterLayout>
    </>
  );
};

export default ChatMessagePage;
